import React from 'react';
import PropTypes from 'prop-types';
import classes from './toggle.scss';
import toggleOn from 'static/images/svg/toggle-on.svg';
import toggleOff from 'static/images/svg/toggle-off.svg';

export const Toggle = ({
    id,
    name,
    isOn,
    disabled = false,
    onToggleClick,
    title = "",
  }) => (
    <button
      id={id}
      name={name}
      type="button"
      className={classes['toggle']}
      onClick={onToggleClick()}
      disabled={disabled}
      title={title}
    >
      {isOn &&
        <img
          alt=""
          src={toggleOn} />}
      {!isOn &&
        <img
          alt=""
          src={toggleOff} />}
    </button>
);

Toggle.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  title: PropTypes.string,
  onToggleClick: PropTypes.func.isRequired,
  isOn: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};

export default Toggle;
